import React from "react";
import { DownloadModal } from "./Components/DownloadModal";
import useModalHandler from "../../../../utils/v3/useModalHandler";
import { useScript } from "../../../../utils/useScript";
import { Modal } from "antd";

export function DownloadVideos() {
    useScript("//open.thunderurl.com/thunder-link.js");
    const modal = useModalHandler({ component: DownloadModal });

    function onClick() {
        if (!window.thunderLink) {
            Modal.error({ content: "无法加载迅雷功能, 请刷新页面重试" });
            return;
        }
        modal.open();
    }

    return (
        <React.Fragment>
            <a onClick={onClick}>下载</a>

            {modal.render()}
        </React.Fragment>
    );
}
